import type { EventBusKey } from '@vueuse/core'

import type { FactoryId, FormId } from '@/types/formStepsFactory'

export type FormStepperEvent = 'abort' | 'complete' | 'next'

export interface PayloadFormStepper {
  event: FormStepperEvent
  factoryId: FactoryId
  formId: FormId
  step: number
}

export const formStepperKey: EventBusKey<PayloadFormStepper> =
  Symbol('form-stepper-key')
